import {AppTerms} from "../../../app/app-terms";
import {BaseModel} from "../../../../infrastructure/models/base-model";

export class DidomiConfigNoticeContentModel extends BaseModel {
  terms: AppTerms;

  constructor(terms: AppTerms) {
    super();

    this.terms = terms;
  }

  get popup(): String {
    return this.terms.DIDOMI_WEB_NOTICE_UNSUPPORTED_LANGS
  }

  get dismiss(): String {
    return this.terms.DIDOMI_WEB_AGREE_BUTTON_UNSUPPORTED_LANGS
  }

  get learnMore(): String {
    return this.terms.DIDOMI_WEB_LEARN_MORE_BUTTON_UNSUPPORTED_LANGS
  }

  getDidomiObject() {
    return {
      popup: {en: this.popup},
      dismiss: {en: this.dismiss},
      learnMore: {en: this.learnMore},
    }
  }
}
